import populateAjsBuilderForm from 'app/components/analytics-builder/populate-ajs-builder-form';
import UPDATE_MODES from 'app/components/analytics-builder/export-import/UPDATE_MODES';

/**
 * Populate form with uploaded analytics file data
 *
 * @param {object} params - Parameters
 * @param {object} params.analyticsFileData - Transformed analytics file data
 * @param {function} params.setField - Form setField function
 * @param {function} params.addIdentitySyncs - Function to add identity sync names to staged list
 * @param {function} params.addIntegrations - Function to add integration names to staged list
 * @param {string} params.updateMode - Update mode (override or merge)
 * @param {array} params.stagedIdentitySyncs - Current staged identity sync names (for merge mode)
 * @param {array} params.stagedIntegrations - Current staged integration names (for merge mode)
 */
export default function populateFormFromUpload({
  analyticsFileData,
  setField,
  addIdentitySyncs,
  addIntegrations,
  updateMode,
  stagedIdentitySyncs = [],
  stagedIntegrations = [],
}) {
  populateAjsBuilderForm({ analyticsFileData, setField, updateMode });

  const finalIdentitySyncNames = computeMergedItemNames({
    uploadedItems: analyticsFileData.identitySyncs,
    currentStagedItemNames: stagedIdentitySyncs,
    updateMode,
  });
  if (finalIdentitySyncNames.length > 0) {
    addIdentitySyncs(finalIdentitySyncNames);
  }

  const finalIntegrationNames = computeMergedItemNames({
    uploadedItems: analyticsFileData.integrations,
    currentStagedItemNames: stagedIntegrations,
    updateMode,
  });
  if (finalIntegrationNames.length > 0) {
    addIntegrations(finalIntegrationNames);
  }
}

/**
 * Compute merged item names based on update mode
 * Maps uploaded items to their names and merges with current staged names based on mode
 *
 * @param {object} params - Parameters
 * @param {array} params.uploadedItems - Items from uploaded file (objects with .name property)
 * @param {array} params.currentStagedItemNames - Current staged item names
 * @param {string} params.updateMode - Update mode (override or merge)
 * @returns {array} Final item names
 */
function computeMergedItemNames({ uploadedItems, currentStagedItemNames, updateMode }) {
  const initialNames = updateMode === UPDATE_MODES.MERGE ? currentStagedItemNames : [];

  const namesSet = uploadedItems.reduce((names, item) => {
    names.add(item.name);
    return names;
  }, new Set(initialNames));

  return Array.from(namesSet);
}
